import { emojifyText } from '../emojify';

export default function twemojify(md) {
    md.block.ruler.after('code', 'emoji', (state, start, end) => {
        function get(state, line) {
            const pos = state.bMarks[line];
            const max = state.eMarks[line];
            return state.src.substr(pos, max - pos);
        }

        if (start !== 0 || state.blkIndent !== 0) {
            return false;
        }
        if (state.tShift[start] < 0) {
            return false;
        }
        const data = [];
        let line;
        for (line = start; line < end; line++) {
            let str = get(state, line);
            if (str.match(/^---$/) || state.tShift[line] < 0) {
                break;
            }
            str = emojifyText(str);
            data.push(str);
        }

        state.src = data.join('\n') || {};

        if (line >= end) {
            return false;
        }
        state.line = line + 1;
        return true;
    }, {alt: []});
}
